
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import Select from '@/components/Select.vue';
import FormInput from '@/components/FormInput.vue';
import Button from '@/components/Button.vue';
import SettingUrl from './SettingUrl.vue';

@Component({
  components: {
    LayoutContent,
    Select,
    FormInput,
    Button,
    SettingUrl,
  },
})

export default class Step3 extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) data!: any;
  @Prop(String) secretKey!: string;
}
